import React, { useState, useEffect, useRef } from 'react';
import DropdownContext from './DropdownContext';

export const initialDropdownState = {
  selectedOption1: '',
  selectedOption2: [],
  TextAreaContent: '',
  textAreaComment: '',
  textAreaContentOeil: '',
  intensiteNez: '',
  selectedColor: '',
  IsEditingWineName: true,
  IsEditingTextAreaContent: true,
  IsEditingTextAreaComment: true,
  date: '',
  WineName: '',
  SavedWineName: '',
  SavedTextAreaContent: '',
  acidite: 1,
  alcool: 1,
  tanins: 1,
  volume: 1,
  longeur_en_bouche: 1,
  smileyRating: 1,
  wineRatings: {
    complexite: 0.5,
    intensite: 0.5,
    equilibre: 0.5,
    longueur: 0.5,
  },
  personalRating: 0,
  showMoreTextarea: '',
  textAreaMore: '',
  vueDensemble: {
    harmonieux: '',
    complexe: '',
    long_en_bouche: '',
  }
};

function DropdownProvider({ children, pageId }) {
  const [dropdownState, setDropdownState] = useState(initialDropdownState);
  // Prevents the save effect from writing stale state when pageId changes.
  // The load effect sets this true; the save effect skips one write then clears it.
  const isLoadingRef = useRef(false);

  // Load saved state whenever pageId changes
  useEffect(() => {
    if (pageId) {
      isLoadingRef.current = true;
      const savedPages = JSON.parse(localStorage.getItem("pages")) || [];
      const existingPage = savedPages.find((page) => page.id === pageId);
      setDropdownState(existingPage ? existingPage.data : initialDropdownState);
    }
  }, [pageId]);

  // Save updated state to localStorage when dropdownState changes.
  // Skips the first write after a pageId change (which would carry the previous page's state).
  useEffect(() => {
    if (pageId) {
      if (isLoadingRef.current) {
        isLoadingRef.current = false;
        return;
      }
      const savedPages = JSON.parse(localStorage.getItem("pages")) || [];
      const updatedPages = savedPages.map((page) =>
        page.id === pageId ? { ...page, data: dropdownState } : page
      );
      localStorage.setItem("pages", JSON.stringify(updatedPages));
    }
  }, [dropdownState, pageId]);

  return (
    <DropdownContext.Provider value={{ dropdownState, setDropdownState }}>
      {children}
    </DropdownContext.Provider>
  );
}

export default DropdownProvider;
